/**
 * iter235 — Badges & libellés partagés du module Gardiennage pneus.
 */
export const TYPE_LABEL = { ete: "Été", hiver: "Hiver" };

export const TYPE_CLASS = {
  ete: "bg-amber-50 text-amber-800 border-amber-200",
  hiver: "bg-sky-50 text-sky-800 border-sky-200",
};

/** Badges d'état d'un gardiennage : stockage + facturation + « pas encore passé ». */
export function badgesOf(g) {
  const out = [];
  if ((g.statut || "stocke") === "stocke") {
    out.push({ key: "stocke", label: "Stocké", cls: "bg-[#52a675]/10 text-[#2d5f3f] border-[#52a675]/30" });
  } else {
    out.push({ key: "sorti", label: "Sorti / monté", cls: "bg-gray-100 text-gray-600 border-gray-300" });
  }
  if (g.a_monter) {
    out.push({ key: "a_monter", label: "Pas encore passé", cls: "bg-orange-50 text-orange-800 border-orange-300" });
  }
  if (g.paye) {
    out.push({ key: "paye", label: "Payé", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" });
  } else if (g.facture_id) {
    out.push({ key: "facture", label: `Facturé ${g.facture_numero || ""}`.trim(), cls: "bg-blue-50 text-blue-800 border-blue-200" });
  } else if (g.facturation_statut === "a_facturer") {
    out.push({ key: "a_facturer", label: "À facturer", cls: "bg-red-50 text-red-700 border-red-200" });
  }
  return out;
}

export const fmtChf = (n) => `${Number(n || 0).toFixed(2)} CHF`;
